(function () {
  'use strict';

  function initRecommendationSliders(root) {
    const scope = root || document;

    const sliders = scope.querySelectorAll(
      '[data-recommendation-slider]'
    );

    sliders.forEach(function (slider) {
      if (slider.dataset.sliderInitialized === 'true') {
        return;
      }

      const track = slider.querySelector('[data-slider-track]');
      const prevButton = slider.querySelector('[data-slider-prev]');
      const nextButton = slider.querySelector('[data-slider-next]');

      if (!track || !prevButton || !nextButton) {
        return;
      }

      const firstSlide = track.querySelector('[data-slider-slide]');

      if (!firstSlide) {
        return;
      }

      slider.dataset.sliderInitialized = 'true';

      function getScrollStep() {
        const slide = track.querySelector('[data-slider-slide]');

        if (!slide) {
          return track.clientWidth;
        }

        const styles = window.getComputedStyle(track);

        const gap =
          parseFloat(
            styles.columnGap || styles.gap || '0'
          ) || 0;

        return slide.offsetWidth + gap;
      }

      function updateButtons() {
        const maxScrollLeft =
          Math.max(
            0,
            track.scrollWidth - track.clientWidth
          );

        prevButton.disabled =
          track.scrollLeft <= 5;

        nextButton.disabled =
          maxScrollLeft <= 5 ||
          track.scrollLeft >= maxScrollLeft - 5;
      }

      prevButton.addEventListener(
        'click',
        function () {
          track.scrollBy({
            left: -getScrollStep(),
            behavior: 'smooth'
          });
        }
      );

      nextButton.addEventListener(
        'click',
        function () {
          track.scrollBy({
            left: getScrollStep(),
            behavior: 'smooth'
          });
        }
      );

      track.addEventListener(
        'scroll',
        updateButtons,
        {
          passive: true
        }
      );

      window.addEventListener(
        'resize',
        updateButtons
      );

      /*
       * Images can change the final width of the cards.
       * Recalculate once the browser has painted.
       */
      requestAnimationFrame(function () {
        updateButtons();
      });

      /*
       * Recalculate after images finish loading.
       */
      track.querySelectorAll('img').forEach(
        function (image) {
          if (!image.complete) {
            image.addEventListener(
              'load',
              updateButtons,
              { once: true }
            );
          }
        }
      );
    });
  }

  /*
   * Expose globally so other components can
   * manually re-initialize after AJAX rendering.
   */
  window.initRecommendationSliders =
    initRecommendationSliders;

  /*
   * Initial page load.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initRecommendationSliders(document);
      }
    );
  } else {
    initRecommendationSliders(document);
  }

  /*
   * Shopify Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initRecommendationSliders(event.target);
    }
  );

  /*
   * Important:
   *
   * Shopify product-recommendations loads
   * products asynchronously.
   *
   * MutationObserver detects the newly inserted
   * recommendation-slider markup.
   */
  const observer = new MutationObserver(
    function (mutations) {
      let shouldInitialize = false;

      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          shouldInitialize = true;
        }
      });

      if (!shouldInitialize) {
        return;
      }

      requestAnimationFrame(function () {
        initRecommendationSliders(document);
      });
    }
  );

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
})();